import { useEffect, useRef, useState } from 'react'
import { logo } from '../../assets/images'
import { scrollWindowToTop } from '../../utils/scrollToTop'

const MIN_VISIBLE_MS = 1100
const FADE_OUT_MS = 650
const MAX_WAIT_MS = 4000

let initialLoadFinished = false

function PageLoader() {
  const [phase, setPhase] = useState(() => (initialLoadFinished ? 'done' : 'loading'))
  const finishedRef = useRef(false)

  useEffect(() => {
    if (initialLoadFinished) return undefined

    document.body.classList.add('is-page-loading')

    const start = Date.now()

    const complete = () => {
      if (finishedRef.current) return
      finishedRef.current = true

      const remaining = Math.max(0, MIN_VISIBLE_MS - (Date.now() - start))

      window.setTimeout(() => {
        setPhase('exit')

        window.setTimeout(() => {
          initialLoadFinished = true
          setPhase('done')
          document.body.classList.remove('is-page-loading')
          scrollWindowToTop()
          window.requestAnimationFrame(scrollWindowToTop)
          window.setTimeout(scrollWindowToTop, 120)
        }, FADE_OUT_MS)
      }, remaining)
    }

    if (document.readyState === 'complete') {
      complete()
    } else {
      window.addEventListener('load', complete, { once: true })
    }

    const fallback = window.setTimeout(complete, MAX_WAIT_MS)

    return () => {
      window.removeEventListener('load', complete)
      window.clearTimeout(fallback)
      document.body.classList.remove('is-page-loading')
    }
  }, [])

  if (phase === 'done') return null

  return (
    <div
      className={`page-loader ${phase === 'exit' ? 'page-loader--exit' : ''}`}
      role="status"
      aria-live="polite"
      aria-label="Loading Torbit Metals"
    >
      <div className="page-loader__backdrop" aria-hidden="true" />
      <div className="page-loader__content">
        <div className="page-loader__stage">
          <div className="page-loader__ring" aria-hidden="true">
            <span className="page-loader__ring-track" />
            <span className="page-loader__ring-spin" />
          </div>
          <div className="page-loader__logo-wrap">
            <img className="page-loader__logo" src={logo} alt="Torbit Metals" />
          </div>
        </div>
        <div className="page-loader__progress" aria-hidden="true">
          <span className="page-loader__progress-bar" />
        </div>
        <p className="page-loader__text">Loading…</p>
      </div>
    </div>
  )
}

export default PageLoader
